module.exports = __webpack_public_path__ + "static/media/italy.29c0f039.jpg";